import { date, resource } from "./app";
import { multiple } from "../utils";

export var user = usr => {
  return new Promise(resolve => {
    resource(usr).then(res => {
      let adapted = res;
      adapted.id = usr.id;
      // Null is sometimes confused with empty strings, so we import only empty strings, no null values
      adapted.firstname = usr.firstname ? usr.firstname : "";
      adapted.lastname = usr.lastname ? usr.lastname : "";
      adapted.email = usr.email ? usr.email : "";
      adapted.phone1 = usr.phone1 ? usr.phone1 : "";
      adapted.phone2 = usr.phone2 ? usr.phone2 : "";
      adapted.role = usr.role ? usr.role : "";
      // Pass the rest of the data
      adapted.pastClasses = usr.past_participations;
      adapted.relation = usr.relation;
      resolve(adapted);
    });
  });
};

export var users = list => {
  return multiple(list, user);
};

const adapters = {
  user,
  users
};

export default adapters;
